import { useSaveGoogleAuthTokenQuery, useScheduleInterviewMutation } from 'services';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Image } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const RedirectPage: React.FC = () => {
	// getting code from query
	const location = useLocation();
	const { translate } = useTranslate();
	const params = new URLSearchParams(location.search);
	const codeParam = params.get('code');

	const { mutateAsync: scheduleInterviewMutation, isPending } = useScheduleInterviewMutation();
	const [msg, setMsg] = useState('');
	const navigate = useNavigate();

	useSaveGoogleAuthTokenQuery(codeParam);
	const payloadForInterview: any = localStorage.getItem('payloadForInterview');

	const handleScheduleInterview = async (payload: any) => {
		try {
			const scheduleResponse = await scheduleInterviewMutation(payload);
			if (scheduleResponse?.success) {
				setMsg(scheduleResponse?.message);
				toast.success(translate('ToastMessage.interViewLinkSent'));
				setTimeout(() => {
					navigate('/company/my-jobs');
				}, 2000);
			}
		} catch (error) {
			toast.error(translate('ToastMessage.generalError'));
		}
	};

	useEffect(() => {
		if (payloadForInterview) {
			handleScheduleInterview(JSON.parse(payloadForInterview));
		}
	}, []);

	return (
		<div className="text-center meeting-success-box d-flex flex-column align-items-center justify-content-center">
			{isPending ? (
				<p>Loading ...</p>
			) : (
				<>
					<Image src={IMAGE_PATHS.SuccessGif} alt="success" loading="lazy" />
					<h2 className="fw-bold mb-0 mt-4">{msg}</h2>
				</>
			)}
		</div>
	);
};

export default RedirectPage;
